import React from 'react'
import {Map, InfoWindow, Marker, GoogleApiWrapper} from 'google-maps-react';
 
const style = {
  width: '100%',
  height: '400px'
}

 class MapContainer extends React.Component {
  render() {
    return (
      <Map google={this.props.google} zoom={14} initialCenter={{
            lat: 23.617241,
            lng: 58.562721
        }} style={style} >
 
        <Marker onClick={this.onMarkerClick}
                name={'Current location'} />
 
        <InfoWindow onClose={this.onInfoWindowClose}>
            
        </InfoWindow>
      </Map>
    );
  }
}
export default GoogleApiWrapper({
  apiKey: ("AIzaSyBey16tIQXAmGxAK_j5H3IsUff0BRY0qlM")
})(MapContainer); 